import React from 'react';
import { Css, IResponsiveImageSource, Responsive } from '@/ui';
import { ReactNode } from 'react-markdown';
import styled from '@emotion/styled';
import BaseCard from '../BaseCard';
import { CardContentStyled, CardPictureStyled, CardTitle } from '../Card/Card';
import { renderMarkdownAsPlainText } from '../../../../utils/renderMarkdownAsPlainText';

interface IFlowyCardProps {
	imageSource?: string | IResponsiveImageSource;
	title: string | ReactNode;
	body?: string | ReactNode;
}

export default function FlowyCard({
	imageSource,
	title,
	body,
}: IFlowyCardProps) {
	const filteredBody = renderMarkdownAsPlainText(body);

	return (
		<BaseCard fullyClickable={false}>
			{imageSource && (
				<FlowyCardPicture source={imageSource} alt={title} fullyClickable />
			)}
			<CardContentStyled fullyClickable={false} isBackgroundSolid flowy>
				<div>
					{typeof title === 'string' ? (
						<StyledFlowyCardTitle aria-label={title}>
							{title}
						</StyledFlowyCardTitle>
					) : (
						title
					)}
					{filteredBody && <FlowyCardBody>{filteredBody}</FlowyCardBody>}
				</div>
			</CardContentStyled>
		</BaseCard>
	);
}

const FlowyCardPicture = styled(CardPictureStyled)`
	img {
		aspect-ratio: 1.4;
		height: auto;
	}
`;

const StyledFlowyCardTitle = styled(CardTitle)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(18)};
	}
`;

const FlowyCardBody = styled.div`
	font-size: ${Css.pxToRem(18)};
	letter-spacing: -0.1px;
	margin-top: ${Css.pxToRem(6)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(16)};
	}
`;
